import type { IData } from '../model/IData'
import { expectDefined } from './expectDefined'
import { getCouples } from './getCouples'

export function getChildren(data: IData, personId: string) {
	return getCouples(data, personId)
		.flatMap((it) => it.childIds ?? [])
		.map((it) => expectDefined(data.personsById[it]))
		.toSorted((a, b) => (a.birthDate ?? '').localeCompare(b.birthDate ?? ''))
}
